// extracted by mini-css-extract-plugin
export var pagination = "pagination-module--pagination--b8a9f";